module.exports = __webpack_public_path__ + "static/assets/49300ca5f861bbbdcc1f9b60424cabec.png";